import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';

Vue.component('holiday', {
    components: {
        datePicker
    },

    props: ['user-id'],

    data () {
        return {
            filter: {
                from: moment().startOf('today').format("DD-MM-YYYY"),
                to: moment().endOf('year').format("DD-MM-YYYY"),
            },

            loading: false,

            holidays: [],

            createForm: $.extend(true, new Form({
                data: {
                    start: moment().format('DD-MM-YYYY'),
                    end: moment().format('DD-MM-YYYY'),
                    time: 'Full Day',
                    type: '',
                    bd_trip: '',
                    bd_trip_date: ''
                }
            }), {}),

            tpOptions: {
                format: 'DD-MM-YYYY',
            },
        };
    },

    mounted () {
        this.getHolidays();
    },

    methods: {
        handleFilterDateSelected (field, value) {
            this.filter[field] = value;
        },

        getHolidays () {
            this.loading = true;
            
            axios.get('/api/holidays/', {
                params: {
                    id: this.userId,
                    ...this.filter
                }
            }).then(response => {
                this.loading = false;
                this.holidays = response.data;
            });
        },

        deleteHoliday(id) {
            this.deleteId = id;
            $('#delete-holiday').modal('show');
        },

        doDeleteHoliday () {
            axios.post('/api/holidays/delete', {}, {
                params: {
                    id: this.deleteId
                }
            }).then(response => {
                $('#delete-holiday').modal('hide');

                this.getHolidays();
            });
        },

        store () {
            Http.post('/api/holidays/create/' + this.userId, this.createForm).then(response => {
                this.getHolidays();

                $('#create-holiday').modal('hide');
            });
        }
    },

    filters: {
        date (value) {
            return value != null ? moment(value).format("DD/MM/YYYY") : value;
        }
    }
});